import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthService } from '../services/auth-service.service';
import { AppGlobalsService } from '../services/app-globals.service';
import { DashboardComponent } from './dashboard.component';

const routes: Routes = [
  {
    path: 'dashboard',
    resolve: {
      globals: AppGlobalsService,
    },
    children: [
      {
        path: '',
        component: DashboardComponent,
        canActivate: [AuthService],
        data: {
          rightNeeded: 'NewDashboardTab',
          breadcrumb: 'Dashboard',
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashRouting {}
